export default __webpack_public_path__ + "static/media/home_smlan_icon.e1256ee6.svg";